<template>
  <div>
    <div v-if="loading" v-loading.lock="loading" class="loader"></div>

    <div v-else class="container">
      <el-button 
        class="closeButton" 
        type="primary" 
        icon="Close" 
        circle
        @click="volver">
      </el-button>

      <el-row>
        <el-col :span="22">
          <div class="title">{{noticia.Titulo}}</div>
        </el-col>

        <el-col :span="2" class="closeIconContainer">
          <router-link :to="{ name: 'Home' }">
            <span><el-icon><CircleClose /></el-icon></span>
          </router-link>
        </el-col>
      </el-row>
      
      <el-row>
        <div class="copete">
          {{noticia.Copete}}
        </div>
      </el-row>
      
      <el-row>
        <div>
          <img v-if="noticia.PathImagen !== ''" class="imagen" :src="noticia.PathImagen" width="400" align="left" >
          <div class="body_content">{{noticia.Cuerpo}}</div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticiaItem',
  data() {
    return {
      noticia: {},
      loading: false
    }
  },
  methods: {
    getNoticia() {

      this.loading = true

      this.$store.dispatch('noticias/getNoticia', {id: this.$route.params.id})
      .then(result => this.noticia = result)
      .finally(() => this.loading = false)
    },

    volver() {
      console.log('back')
      this.$router.push({ name: "Home" })
    }
  },
  // created() {
  //   this.getNoticia()
  // },
    mounted() {
    let id = this.$route.params.id
    this.getNoticia(id)
  }
}
</script>


<style scoped>
.loader {
  margin-top: 20px;
  height: 50px;
}

.container {
  padding: 20px 40px 20px 20px;
  text-align: left;
}
.title {
  font-weight: bold;
  font-size: 42px;
  line-height: 49px;
  color: var(--main-color);
  padding-bottom: 7px;
  width: fit-content;
  border-bottom: 2px solid var(--main-color); 
}
.closeIconContainer {
  padding: 9px 0px;
  text-align: right;
}
.closeIconContainer span {
  font-size: 35px;
  cursor: pointer;
}
.copete {
  margin: 20px 0px 20px 0px;
}
.imagen {
  padding-right: 30px;
}
.body_content {
  line-height: 21px;
  text-align: justify;
}

.closeButton {
  position: fixed;
  right: 20px;
  height: 50px;
  width: 50px;
}
</style>

